import { Link } from "react-router-dom";
import { BUSINESS_NAME, BUSINESS_WA } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-900 mt-24 bg-[#0A0A0C]" data-testid="site-footer">
      {/* Location map */}
      <div className="border-b border-zinc-900" data-testid="footer-map">
        <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-8 items-center">
          <div>
            <div className="overline">Visit the studio</div>
            <h3 className="font-display text-2xl mt-2">Navi Mumbai.</h3>
            <p className="text-sm text-zinc-400 mt-3 leading-relaxed">
              Shop no 2 &amp; 3, Plot no 21,<br />
              next to Sharayu Hyundai showroom,<br />
              Sector 1, Shiravane, Nerul,<br />
              Navi Mumbai, Maharashtra 400706
            </p>
            <a
              href="https://www.google.com/maps/dir/?api=1&destination=Tech+Detailers+Sharayu+Hyundai+Shiravane+Navi+Mumbai+Maharashtra"
              target="_blank" rel="noopener noreferrer"
              className="btn-outline text-sm mt-5 inline-flex" data-testid="directions-btn"
            >
              Get directions →
            </a>
          </div>
          <div className="md:col-span-2 rounded-lg overflow-hidden border border-zinc-900">
            <iframe
              title="Tech Detailers Navi Mumbai location"
              src="https://maps.google.com/maps?q=Tech%20Detailers%20Sharayu%20Hyundai%20Shiravane%20Navi%20Mumbai%20Maharashtra%20400706&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%" height="260"
              style={{ border: 0, filter: "grayscale(0.4) contrast(1.1)" }}
              loading="lazy" referrerPolicy="no-referrer-when-downgrade"
              data-testid="google-map-iframe"
            />
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="font-display text-xl mb-3">Tech <span className="text-[#FFB800]">Detailers</span></div>
          <p className="text-sm text-zinc-400 max-w-xs">Premium car care studio · Garware Application Centre. PPF, ceramic, graphene, sunfilms & detailing.</p>
        </div>
        <div>
          <div className="overline mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/services" className="hover:text-white">Services</Link></li>
            <li><Link to="/quote" className="hover:text-white">Instant Quote</Link></li>
            <li><Link to="/portfolio" className="hover:text-white">Portfolio</Link></li>
            <li><Link to="/warranty" className="hover:text-white">Warranty</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Company</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/booking" className="hover:text-white">Book Appointment</Link></li>
            <li><Link to="/track" className="hover:text-white">Track My Car</Link></li>
            <li><Link to="/dashboard" className="hover:text-white">My Dashboard</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline mb-3">Contact</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li>WhatsApp: <a href={`https://wa.me/${BUSINESS_WA.replace(/^\+/, "")}`} className="text-[#FFB800]">{BUSINESS_WA}</a></li>
            <li className="text-xs leading-relaxed text-zinc-400">
              Shop no 2 &amp; 3, Plot no 21,<br />
              next to Sharayu Hyundai showroom,<br />
              Sector 1, Shiravane, Nerul,<br />
              Navi Mumbai, Maharashtra 400706
            </li>
            <li>Hours: Mon–Sun · 10:00–20:00 IST</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-900 py-5 text-center text-xs text-zinc-500">
        © {new Date().getFullYear()} {BUSINESS_NAME}. All rights reserved.
      </div>
    </footer>
  );
}
